import { email, max, required } from 'vee-validate/dist/rules';
import { setInteractionMode } from 'vee-validate';
import { extend } from 'vee-validate';

setInteractionMode('lazy');

// INSTALLED RULES
extend('required', { ...required });
extend('email', { ...email });
extend('max', { ...max });
